var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"id":"main-container","fluid":""}},[_c('Navbar'),_c('AlertEmail'),_c('AlertCertificato'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }